import { render, staticRenderFns } from "./GoToCheckoutButton.vue?vue&type=template&id=335badf8&scoped=true"
import script from "./GoToCheckoutButton.vue?vue&type=script&lang=js"
export * from "./GoToCheckoutButton.vue?vue&type=script&lang=js"
import style0 from "./GoToCheckoutButton.vue?vue&type=style&index=0&id=335badf8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "335badf8",
  null
  
)

export default component.exports